"use client"

import { Header } from "@/components/header"
import { useAdminStatus } from "@/hooks/useAdminStatus"

export default function HeaderWrapper() {
  const isAdmin = useAdminStatus()
  return (
    <Header isAdmin={isAdmin} />
  )
}

